module.exports = __webpack_public_path__ + "img/CUFFLBP.a57a516c.jpg";